import { useGetZuoraOutageStatusQuery } from '../../__generated__/chirp/com/hubspot/fintech/outages/rpc/FintechOutagesRpc.hooks';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
import { isFunction } from '../utils/function';
const parseHubId = hubId => {
  if (hubId === null) return undefined;
  const parsed = Number.parseInt(hubId, 10);
  return Number.isFinite(parsed) ? parsed : undefined;
};
const toOutageReason = reason => {
  if (reason === OUTAGE_REASONS.PLANNED_OUTAGE || reason === OUTAGE_REASONS.UNPLANNED_OUTAGE) {
    return reason;
  }
  return undefined;
};
const useFetchFintechOutagesStatus = (hubId, onError) => {
  const {
    data
  } = useGetZuoraOutageStatusQuery({
    variables: {
      hubId: parseHubId(hubId)
    },
    onError(err) {
      if (isFunction(onError)) {
        onError(err);
      }
    }
  });
  return {
    zuora: {
      isDown: !!(data !== null && data !== void 0 && data.down),
      outageReason: toOutageReason(data === null || data === void 0 ? void 0 : data.reason),
      outageStartTime: data === null || data === void 0 ? void 0 : data.startTime,
      outageEndTime: data === null || data === void 0 ? void 0 : data.endTime
    }
  };
};
export default useFetchFintechOutagesStatus;